var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('ClientDrugShoplistList',{attrs:{"title":"Лист покупок","prescriptions":_vm.tobuy}}),_c('ClientDrugShoplistList',{attrs:{"title":"Куплено","prescriptions":_vm.bought}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }